import authService from '../api-authorization/AuthorizeService'
//import * as XLSX from 'xlsx/xlsx.mjs';
import * as XLSX from 'xlsx-js-style';

export default class ReportePesosService {
    async ReportePesos(semana) {
        const token = await authService.getAccessToken();
        const queryString = '?semana_Id=' + semana.semana_Id;
        const response = await fetch('api/ContenedoresSemanales/GetAdmin' + queryString, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
        });

        const rows = await response.json();

        let blsData = this.getBLS(rows);
        blsData.forEach(function (v) {
            delete v.fake_Id;
            delete v.pesoTara;
            return v;
        });

        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet([]);

        // Add headers
        const heading = [[
            'Proveedor', 'Destino', 'BL', 'Contenedores', 'Peso Neto', 'Peso Bruto', 'Cant. Paletas', 'Cajas',
            //'Peso Tara',
            'VGM'
        ]];
        XLSX.utils.sheet_add_aoa(worksheet, heading);

        var style_h1 = {
            fill: { fgColor: { rgb: "92D050" } },
            alignment: { horizontal: "center", vertical: "top" },
            font: {
                name: 'Calibri',
                sz: 11,
                //color: { rgb: "#FF000000" },
                bold: true,
                italic: false,
                underline: false,
            },
            border: {
                top: { style: "thin", color: { auto: 1 } },
                right: { style: "thin", color: { auto: 1 } },
                bottom: { style: "thin", color: { auto: 1 } },
                left: { style: "thin", color: { auto: 1 } }
            }
        }

        // Apply style to header row
        const headerRange = XLSX.utils.decode_range("A1:I1");
        for (let C = headerRange.s.c; C <= headerRange.e.c; ++C) {
            const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
            if (!worksheet[cellAddress]) continue;
            worksheet[cellAddress].s = style_h1;
        }

        // Add data
        XLSX.utils.sheet_add_json(worksheet, blsData, { origin: 'A2', skipHeader: true });

        // Set column widths
        const columnWidths = [
            { wch: 30 }, // Proveedor
            { wch: 30 }, // Destino
            { wch: 30 }, // BL
            { wch: 80 }, // Contenedores
            { wch: 15 }, // Peso Neto
            { wch: 15 }, // Peso Bruto
            { wch: 30 }, // Paletizados
            { wch: 15 }, // Cajas
            //{ wch: 15 }, // Peso Tara
            { wch: 15 }, // VGM
        ];
        worksheet['!cols'] = columnWidths;

        // Apply autofilter
        worksheet['!autofilter'] = { ref: "A1:I1" };

        // Append sheet to workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Reporte Pesos');

        // Write file
        XLSX.writeFile(workbook, `ReportePesos_${semana.nombre}.xlsx`, { compression: true });
    }

    getBLS(data) {
        const blsData = data.reduce((acc, item, index) => {
            // Find the existing group by 'bl'
            let group = acc.find(g => g.proveedor == item.proveedor && g.bl === item.bl && g.destino === item.destino);

            if (!group) {
                // If the group doesn't exist, create a new one
                group = {
                    fake_Id: acc.length + 1, // Assign a unique ID based on the current number of groups
                    proveedor: item.proveedor,
                    destino: item.destino,
                    bl: item.bl,
                    contenedores: "",
                    cajas: 0,
                    paletizados: 0,
                    pesoBruto: 0,
                    pesoNeto: 0,
                    pesoTara: 0,
                    vgm: 0
                };
                acc.push(group);
            }

            // Append the contenedor to the group as a comma-separated string
            group.contenedores = group.contenedores
                ? group.contenedores + ", " + item.contenedor
                : item.contenedor;

            // Add all values to their respective sums (consider null as 0)
            group.pesoNeto += item.pesoNeto || 0;
            group.pesoBruto += item.pesoBruto || 0;
            group.paletizados += item.paletizados || 0;
            group.cajas += item.cajas || 0;
            group.pesoTara += item.pesoTara || 0;
            group.vgm += item.vgm || 0;

            return acc;
        }, []);

        blsData.sort((a, b) => {
            if (a.proveedor < b.proveedor) return -1;
            if (a.proveedor > b.proveedor) return 1;

            if (a.destino < b.destino) return -1;
            if (a.destino > b.destino) return 1;

            if (a.bl < b.bl) return -1;
            if (a.bl > b.bl) return 1;

            return 0;
        });

        return blsData;
    }
}


function getFormattedDate(date) {
    date = new Date(date)
    var year = date.getFullYear();

    var month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;

    var day = date.getDate().toString();
    day = day.length > 1 ? day : '0' + day;

    return day + '/' + month + '/' + year;
}